export default {
	tenantId: "tokiomarine_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "tokiomarine--uat"
	}
}
